var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center",class:[ 'header__' + _vm.name, _vm.sortable ? 'sortable' : '' ]},[_c('span',[_vm._t("default")],2),(_vm.sortable)?_c('span',{staticClass:"carret",class:{'carret-up': !_vm.sortingActive || _vm.sortingDir === '+', 'carret-down': !_vm.sortingActive || _vm.sortingDir === '-'}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }